<template>
  <div class="unauthorized-container">
    <div class="text-container">
      <p>
        {{ $t('error.unauthorized.youAreUnableToView') }}
      </p>
      <p>
        {{ $t('error.common.contactSupport') }} <a class="link" href="mailto:lab.innovation@ca-indosuez.com">lab.innovation@ca-indosuez.com</a>.
      </p>
    </div>
    <p>
      You have to connect.
    </p>
  </div>
</template>
<script>
export default {
  name: 'Unauthorized',
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.link {
    color: $primary-color;
    cursor: pointer;
}

.unauthorized-container {
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  width: 500px;
  margin-top: 30px;
  padding: 30px 60px;

  background-color: white;
  box-shadow: 2px 2px 8px 0 rgba(69, 69, 69, 0.20);
  border-radius: 2px;

  .text-container {
    width: 500px;
    text-align: justify;
    text-justify: inter-word;
    color: $black-color;
  }
}

</style>
